import { TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useEffect, useState } from 'react';

import { t } from '../../../services/translation/translation';
import { formatTimeBySeconds } from '../../../utils/date';

type Props = {
  trip: TripOutput;
};

export const TimerDriverOnTime = ({ trip }: Props) => {
  const [timer, setTimer] = useState<number>(0);
  const departureAt = trip.resume.departureAt;
  const inDaPlaceAt = trip.resume.history?.inDaPlaceAt;
  const isOnTime = !!inDaPlaceAt && departureAt >= inDaPlaceAt;

  useEffect(() => {
    const startedAt = Math.max(trip.resume.departureAt, trip.resume.history?.inDaPlaceAt ?? 0);
    const timeElapsed = startedAt && Date.now() - startedAt;
    if (timeElapsed && timeElapsed > 0) {
      setTimer(Math.ceil(timeElapsed / 1000));

      const interval = setInterval(() => setTimer(t => t + 1), 1000);

      return () => clearInterval(interval);
    } else {
      setTimer(0);
    }
  }, [trip.resume.departureAt, trip.resume.history?.inDaPlaceAt]);

  return (
    <>
      <div className="flex-col flex w-full">
        <strong>
          {isOnTime ? t('share-route.trip-detail.title-on-time') : t('share-route.trip-detail.title-driver-waiting')}
        </strong>
        {trip.tripVars.freeWaitingMinutes ? (
          <span>
            <div
              dangerouslySetInnerHTML={{
                __html: t('share-route.trip-detail.minutes-free', { time: trip.tripVars.freeWaitingMinutes }),
              }}
            />
          </span>
        ) : null}
      </div>
      {timer ? (
        <div className="flex-col flex bg-background p-1 rounded border-primary border-solid border-2">
          <strong>{formatTimeBySeconds(timer)}</strong>
        </div>
      ) : null}
    </>
  );
};
